module.exports = __webpack_public_path__ + "static/media/key-area-1.8fc2c0ad.png";